<interview-wrapper [title]="'interviews.Interview Complete' | translate">
    <div step-content>
        <p *ngIf="current && current.enable_student_feedback != 0" class="body">
            {{'interviews.Interview Complete Text' | translate}}
        </p>
        <p *ngIf="current && current.enable_student_feedback == 0" class="body">
            {{'interviews.Interview Complete No Feedback' | translate}}
        </p>
    </div>
    <div step-actions>
        <button type="button" *ngIf="current && current.enable_student_feedback != 0 && _dataService.hasAvailableReviewerTypes"(click)="openRequestFeedbackModal();" class="btn btn_primary">{{'interviews.Request Feedback' |
            translate}}
        </button>
        <button type="button" [routerLink]="['../review']" [queryParams]="{ attempt_id : _dataService.attemptId }" class="btn btn_secondary">{{'interviews.Review Interview' | translate}}
        </button>
    </div>
</interview-wrapper>
